const BYPASS_CONFIRM_LEAVE_KEY = '__bypass_confirm_leave_once__';

export function bypassConfirmLeaveOnce() {
	if (typeof window === 'undefined') return;
	window.sessionStorage.setItem(BYPASS_CONFIRM_LEAVE_KEY, 'true');
}

export function consumeConfirmLeaveBypass(): boolean {
	if (typeof window === 'undefined') return false;

	const shouldBypass =
		window.sessionStorage.getItem(BYPASS_CONFIRM_LEAVE_KEY) === 'true';

	if (shouldBypass) {
		window.sessionStorage.removeItem(BYPASS_CONFIRM_LEAVE_KEY);
	}

	return shouldBypass;
}
